exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_widgets_2qVvwcWYMeousZDKmEsNw2 {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_3OUyo6UdohTU9_8dkd-cF3 {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_2d_jarBqq3-WF_BvFts6ib {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_2O0TQiXaVDwHeuVvjFVidv {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_widgets": "IA_widgets_2qVvwcWYMeousZDKmEsNw2",
	"IA_filters": "IA_filters_3OUyo6UdohTU9_8dkd-cF3",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_2d_jarBqq3-WF_BvFts6ib",
	"IA_paginationPageCount": "IA_paginationPageCount_2O0TQiXaVDwHeuVvjFVidv"
};